<template>
  <div>

    <v-layout justify-end>
      <v-btn 
      icon
      @click="expand = !expand">
        <v-icon v-if="isEqual" color="green">
          mdi-file-compare
        </v-icon>
        <v-icon v-else color="red">
          mdi-file-compare
        </v-icon>
      </v-btn>
    </v-layout>

    <v-expand-transition v-if="false">
      <div v-show="expand">
        <v-sheet class="pa-2 ma-2">

          <v-layout justify-end>
            <v-checkbox v-model="settings.showTypes" label="Show types" class="shrink" color="color1"></v-checkbox>
          </v-layout>

          <!-- ERROR -->
          <div 
          v-if="mode === -1"
          class="red--text">
            <div class="title">
              Error: Items are not of the same type.
            </div>
            <div>
              Item 1: {{ typeof item1 }}
            </div>
            <div>
              Item 2: {{ typeof item2 }}
            </div>
          </div>


          <v-layout>
            <v-flex xs6 class="caption panel">
              <div class="c-card">
                <slot name="item1Header"></slot>
                <row :item1="item1" :item2="item2" :settings="settings"></row>
              </div>
            </v-flex>
            <v-flex xs6 class="caption panel">
              <div class="c-card">
                <slot name="item2Header"></slot>
                <row :item1="item2" :item2="item1" :settings="settings"></row>
              </div>
            </v-flex>
          </v-layout>
          <!-- MAIN -->
          <v-layout>
            <v-flex xs6 class="caption panel">
              
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <template v-slot:header>
                    <div>Raw</div>
                  </template>
                  <v-card>
                    <div v-html="stringDiff1" class="pa-2">
                    </div>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>

            </v-flex>
            <v-flex xs6 class="caption panel">
              
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <template v-slot:header>
                    <div>Raw</div>
                  </template>
                  <v-card>
                    <div v-html="stringDiff2" class="pa-2">
                    </div>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>

            </v-flex>
          </v-layout>

        </v-sheet>
      </div>
    </v-expand-transition>

    <v-bottom-sheet v-if="viewMode === 0" v-model="expand">
      <v-card class="c-flex-c1 background" style="max-height: 90vh;overflow: hidden;">

        <v-layout justify-end class="c-flex-00a">
          <v-btn @click="viewMode = 1" icon>
            <v-icon>mdi-page-layout-sidebar-left</v-icon>
          </v-btn>
          <v-layout justify-center align-center>
            <template v-if="isEqual">
              <span class="green--text title">EQUAL</span>
            </template>
            <template v-else>
              <span class="red--text title">NOT EQUAL</span>
            </template>
          </v-layout>
          <v-btn
            icon
            @click="expand = !expand"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-layout>

        <div class="background" style="overflow: auto;">
          <div>

            <v-layout justify-end>
              <v-checkbox v-model="settings.showTypes" label="Show types" class="shrink" color="color1"></v-checkbox>
            </v-layout>

            <!-- ERROR -->
            <div 
            v-if="mode === -1"
            class="red--text">
              <div class="title">
                Error: Items are not of the same type.
              </div>
              <div>
                Item 1: {{ typeof item1 }}
              </div>
              <div>
                Item 2: {{ typeof item2 }}
              </div>
            </div>


            <v-layout>
              <v-flex xs6 class="caption panel">
                <v-card>
                  <slot name="item1Header"></slot>
                  <row :item1="item1" :item2="item2" :settings="settings" class="pa-4"></row>
                </v-card>
              </v-flex>
              <v-flex xs6 class="caption panel">
                <v-card>
                  <slot name="item2Header"></slot>
                  <row :item1="item2" :item2="item1" :settings="settings" class="pa-4"></row>
                </v-card>
              </v-flex>
            </v-layout>
            <!-- MAIN -->
            <v-layout>
              <v-flex xs6 class="caption panel">
                
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header v-slot="{ open }">
                        <div>Raw</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card>
                        <div v-html="stringDiff1" class="pa-2">
                        </div>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

              </v-flex>
              <v-flex xs6 class="caption panel">
                
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header v-slot="{ open }">
                        <div>Raw</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card>
                        <div v-html="stringDiff2" class="pa-2">
                        </div>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

              </v-flex>
            </v-layout>

          </div>
        </div>
      </v-card>
    </v-bottom-sheet>

    <v-navigation-drawer
      v-if="viewMode === 1"
      v-model="expand"
      fixed
      width="500px"
      class="background"
      temporary
    >

      <img src="@/assets/img/icons/pvlogo.png" alt="cardboard box" width="42px">

      <v-btn @click="viewMode = 0" icon>
        <v-icon>mdi-page-layout-footer</v-icon>
      </v-btn>

      <v-divider></v-divider>

      <v-sheet class="pa-2 ma-2">

        <v-layout justify-end>
          <v-checkbox v-model="settings.showTypes" label="Show types" class="shrink" color="color1"></v-checkbox>
        </v-layout>

        <!-- ERROR -->
        <div 
        v-if="mode === -1"
        class="red--text">
          <div class="title">
            Error: Items are not of the same type.
          </div>
          <div>
            Item 1: {{ typeof item1 }}
          </div>
          <div>
            Item 2: {{ typeof item2 }}
          </div>
        </div>


        <v-layout>
          <v-flex xs6 class="caption panel">
            <div class="c-card">
              <slot name="item1Header"></slot>
              <row :item1="item1" :item2="item2" :settings="settings"></row>
            </div>
          </v-flex>
          <v-flex xs6 class="caption panel">
            <div class="c-card">
              <slot name="item2Header"></slot>
              <row :item1="item2" :item2="item1" :settings="settings"></row>
            </div>
          </v-flex>
        </v-layout>
        <!-- MAIN -->
        <v-layout>
          <v-flex xs6 class="caption panel">
            
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <template v-slot:header>
                    <div>Raw</div>
                  </template>
                  <v-card>
                    <div v-html="stringDiff1" class="pa-2">
                    </div>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

          </v-flex>
          <v-flex xs6 class="caption panel">
            
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <template v-slot:header>
                    <div>Raw</div>
                  </template>
                  <v-card>
                    <div v-html="stringDiff2" class="pa-2">
                    </div>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

          </v-flex>
        </v-layout>

      </v-sheet>
    </v-navigation-drawer>

  </div>
</template>

<script>
import _ from 'lodash'
import Row from './components/row'

export default {
  props: ['item1', 'item2'],
  data () {
    return {
      viewMode: 0, // 0 = bottom sheet, 1 = nav drawer
      settings: {
        showTypes: false
      },
      expand: false
    }
  },
  components: {
    'row': Row
  },
  computed: {
    isEqual () {
      return _.isEqual(this.item1, this.item2)
    },
    str1 () {
      if (typeof this.item1 !== 'string') {
        return JSON.stringify(this.item1)
      }
      return this.item1
    },
    str2 () {
      if (typeof this.item2 !== 'string') {
        return JSON.stringify(this.item2)
      }
      return this.item2
    },
    mode () {
      if (typeof this.item1 !== typeof this.item2) {
        return -1 // items are not of equal type
      }
      if (typeof this.item1 === 'object') {
        return 0
      }
    },
    stringDiff1 () {
      var text = ''
      this.str1.split('').forEach((val, i) => {
        if (val !== this.str2.charAt(i)) {
          text += '<span class="highlight-diff">' + val + '</span>'
        } else {
          text += val
        }
      })
      return text
    },
    stringDiff2 () {
      var text = ''
      this.str2.split('').forEach((val, i) => {
        if (val !== this.str1.charAt(i)) {
          text += '<span class="highlight-diff">' + val + '</span>'
        } else {
          text += val
        }
      })
      return text
    }
  },
  created () {
    console.warn('t-item-diff can slow down large data sets considerably!')
  }
}
</script>

<style scoped lang="scss">
.panel {
  word-wrap: break-word;
  padding: 6px;
}
/* use a background because sometimes the diff will be whitespace */
::v-deep .highlight-diff {
  background: rgba(2, 0, 250, 0.1);
  font-weight: bold;
  font-size: 14px;
  line-height: 3rem;
}
</style>

